import { ArchiveIcon } from '@heroicons/react/outline';
import * as React from 'react';
import './Table.scss';
import { UseMutationResult } from 'react-query';
import { ReactComponent as NotFound } from '@/assets/img/not-found.svg';
import ReactPaginate from 'react-paginate';
type TableColumn<Entry> = {
  title: string;
  field: keyof Entry;
  width?: number;
  HeaderCell?(): React.ReactElement;
  Cell?({ entry }: { entry: Entry }): React.ReactElement;
  hide?: boolean;
};

export type TableProps<Entry> = {
  data?: Entry[];
  columns: TableColumn<Entry>[];
  tableInitialState: {
    tableTotalRecords: number;
    tablePageIndex: number;
  };
  isDataLoading?: boolean;
  showPagination?: boolean;
  onTableStateChange?: (pageIndex: number, reset: boolean) => any;
  children?: React.ReactElement;
};

export const TableData = <Entry extends { id?: string }>({
  data,
  columns,
  tableInitialState,
  isDataLoading,
  onTableStateChange,
  children,
  showPagination,
}: TableProps<Entry>) => {
  //const [selectedPage, setSelectedPage] = React.useState(1);
  const tableContainerRef = React.useRef<HTMLDivElement>(null);

  // React.useEffect(() => {
  //   if (selectedPage != tableInitialState.tablePageIndex) {
  //     setSelectedPage(tableInitialState?.tablePageIndex);
  //   }
  // }, [tableInitialState.tablePageIndex]);

  const fetchMoreOnBottomReached = (containerRefElement?: HTMLDivElement | null) => {
    if (containerRefElement && !showPagination) {
      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      if (scrollHeight - scrollTop - clientHeight < 50 && !isDataLoading) {
        getNextSetOfData();
      }
    }
  };

  const getNextSetOfData = () => {
    const totalRecords = data && data.length ? data.length : 0;
    if (totalRecords < tableInitialState.tableTotalRecords) {
      onTableStateChange && onTableStateChange(tableInitialState.tablePageIndex + 1, false);
      //setSelectedPage(selectedPage + 1);
    }
  };

  const handlePageClick = (event: any) => {
    onTableStateChange && onTableStateChange(event.selected + 1, true);
  };
  if (!children && !data?.length && !isDataLoading) {
    return (
      <>
        {window.location.pathname == '/app/events' ? (
          <div className="not-found">
            <div className="n-found-img-outer">
              <NotFound />
            </div>

          </div>
        ) : (
          <div className="flex flex-col items-center justify-center text-gray-500 bg-white h-80 width-100">
            <ArchiveIcon className="not-found-40" />
            <h4 className='no-data-found'>
              {'No Data Found'}
            </h4>
          </div>
        )}
      </>
    );
  }
  return (
    <div style={{"width": '100%'}}>
      <div
        className={`table-container ${showPagination ? 'pagination' : ''}`}
        onScroll={(e) => fetchMoreOnBottomReached(e.target as HTMLDivElement)}
        ref={tableContainerRef}
      >
        <table className="petsked-table min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              {columns.map(({ HeaderCell, title, width, hide }, index) =>
                hide ? null : (
                  <th
                    key={title + index}
                    scope="col"
                    style={{ width: `${width}%`, maxWidth: `${width}%` }}
                    className="px-6 py-3 text-lg font-medium tracking-wider text-left text-gray-500 uppercase"
                  >
                    {HeaderCell ? (
                      <span className="d-flex items-center">
                        <HeaderCell />
                        {title}
                      </span>
                    ) : (
                      title
                    )}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((entry, entryIndex) => (
                <tr key={entry?.id || entryIndex} className="odd:bg-white">
                  {columns.map(({ Cell, field, title, hide }, columnIndex) =>
                    hide ? null : (
                      <td
                        key={title + columnIndex}
                        className="px-6 py-2 text-lg font-medium text-gray-400 whitespace-nowrap"
                      >
                        {Cell ? <Cell entry={entry} /> : entry[field]}
                      </td>
                    )
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {showPagination && tableInitialState.tableTotalRecords > 1 && (
        <div className="pagination-outer">
          <ReactPaginate
            nextLabel="Next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={tableInitialState.tableTotalRecords}
            previousLabel="Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            forcePage={0}
          />
        </div>
      )}
      {!data || (data?.length == 0 && children ? children : <></>)}
    </div>
  );
};
